import { Config } from "@puckeditor/core"

export { Hero } from "./blocks/hero"
export { Features } from "./blocks/features"
export { Pricing } from "./blocks/pricing"
export { FAQ } from "./blocks/faq"
export { CTA } from "./blocks/cta"
export { Gallery } from "./blocks/gallery"
export { Text } from "./blocks/text"
export { Image } from "./blocks/image"
export { Form, FormBody } from "./blocks/form"
export type { FormProps, FormBodyProps, FormField } from "./blocks/form"
export { Footer } from "./blocks/footer"
export { Header } from "./blocks/header"
export { ProductShowcase } from "./blocks/product-showcase"
export { ProductCard } from "./blocks/product-card"
export { Cart } from "./blocks/cart"
export { RichText } from "./blocks/rich-text"
export { Quote } from "./blocks/quote"
export { ProductList } from "./blocks/product-list"

import { Hero, HeroProps } from "./blocks/hero"
import { Features, FeaturesProps } from "./blocks/features"
import { Pricing, PricingProps } from "./blocks/pricing"
import { FAQ, FAQProps } from "./blocks/faq"
import { CTA, CTAProps } from "./blocks/cta"
import { Gallery, GalleryProps } from "./blocks/gallery"
import { Text, TextProps } from "./blocks/text"
import { Image, ImageProps } from "./blocks/image"
import { Form, FormProps } from "./blocks/form"
import { Footer, FooterProps } from "./blocks/footer"
import { Header, HeaderProps } from "./blocks/header"
import { ProductShowcase, ProductShowcaseProps } from "./blocks/product-showcase"
import { ProductCard, ProductCardProps } from "./blocks/product-card"
import { Cart, CartProps } from "./blocks/cart"
import { RichText, RichTextProps } from "./blocks/rich-text"
import { Quote, QuoteProps } from "./blocks/quote"
import { ProductList, ProductListProps } from "./blocks/product-list"

/**
 * Shape of the puck payload `content` array. Kept as a type map so both the
 * editor config and the future storefront renderer consume the same blocks.
 */
export type SiteBlocks = {
  Hero: HeroProps
  Features: FeaturesProps
  Pricing: PricingProps
  FAQ: FAQProps
  CTA: CTAProps
  Gallery: GalleryProps
  Text: TextProps
  Image: ImageProps
  Form: FormProps
  Footer: FooterProps
  Header: HeaderProps
  ProductShowcase: ProductShowcaseProps
  ProductCard: ProductCardProps
  Cart: CartProps
  RichText: RichTextProps
  Quote: QuoteProps
  ProductList: ProductListProps
}

export type SiteConfig = Config<SiteBlocks>

export const siteComponents: SiteConfig["components"] = {
  Hero,
  Features,
  Pricing,
  FAQ,
  CTA,
  Gallery,
  Text,
  Image,
  Form,
  Footer,
  Header,
  ProductShowcase,
  ProductCard,
  Cart,
  RichText,
  Quote,
  ProductList,
}

/**
 * Empty payload used when a page has no draft yet.
 */
export const emptyPuckData = { content: [], root: {} }

export type PuckData = {
  content: { type: string; props: Record<string, unknown> }[]
  root: Record<string, unknown>
  zones?: Record<string, unknown>
}

export * from "./lib/section"
export * from "./lib/resolvers"
export * from "./theme/fonts"
export * from "./theme/tokens"
export * from "./theme/presets"
export {
  resolveTheme,
  themeToCss,
  DEFAULT_RADIUS,
} from "./theme/theme-to-css"
export { StaticPreview } from "./static-preview"
export { blogComponents } from "./blog-components"
